import React from 'react';
import { Box, Button, Link } from '@cardboard-ui/react';
import { useLocation, useResolvedPath } from 'react-router-dom';

export const SpaceModuleNavigator = ({
  links,
}: {
  links: (SpaceModuleLinkProps | SpaceModuleIndexProps)[];
}) => {
  return (
    <Box
      w="100%"
      whiteSpace="nowrap"
      overflow="auto"
      textAlign="center"
      sx={{
        '--webkit-overflow-scrolling': 'touch',
        '-ms-overflow-style': '-ms-autohiding-scrollbar',
        '&::-webkit-scrollbar': { display: 'none' },
      }}
    >
      {links.map(({ label, ...props }) => (
        <SpaceModuleLink key={label} label={label} {...props} />
      ))}
    </Box>
  );
};

interface SpaceModuleProps {
  label: string;
}
export interface SpaceModuleIndexProps extends SpaceModuleProps {
  index: true;
}
export interface SpaceModuleLinkProps extends SpaceModuleProps {
  to: string;
}

const SpaceModuleLink = ({
  label,
  ...props
}: SpaceModuleLinkProps | SpaceModuleIndexProps) => {
  const currentPathname = useLocation().pathname;
  const to = { to: '', ...props }.to; // Have a default "to"
  let toPathname = useResolvedPath(to).pathname;
  toPathname = toPathname.endsWith('/')
    ? toPathname.substring(0, toPathname.length - 1)
    : toPathname;
  const isActive = currentPathname === toPathname;

  return (
    <Button
      as={Link}
      to={toPathname}
      role="tab"
      borderRadius="full"
      fontWeight="semibold"
      fontSize="sm"
      py={0}
      px={2}
      my={1}
      variant="solid"
      height="1.5rem"
      overflow="hidden"
      aria-selected={isActive ? 'true' : 'false'}
      color={isActive ? 'var(--bar-bg)' : 'var(--bar-color)'}
      bgColor={isActive ? 'var(--bar-color)' : 'var(--bar-bg)'}
      transition="background-color .3s ease, color .3s ease"
    >
      {label}
    </Button>
  );
};
